import { Button, Form, Modal } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import GlobalContext from "../../../context/GlobalContext";
import { CheckCircle, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ModalChooseTypeHomologation = (props) => {
  const { openModal, setOpenModal } = props;
  const { t } = useTranslation();
  const { form, setGlobalData } = useContext(GlobalContext);
  const [selectedType, setSelectedType] = useState(null);
  const navigate = useNavigate();
  const data = openModal !== "" ? JSON.parse(openModal) : openModal;
  
  const getCardStyle = (type) => ({
    cursor: "pointer",
    border: `2px solid ${selectedType === type ? "#214082" : "#ddd"}`,
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "80px",
    backgroundColor: selectedType === type ? "#f0f5ff" : "#fff",
    boxShadow: selectedType === type ? "0 0 10px rgba(33,64,130,0.2)" : "none",
    transition: "all 0.3s ease",
    fontWeight: "500",
    fontSize: "16px",
  });

  return (
    <Modal
      title={
        <span style={{ fontSize: "20px", fontWeight: "600" }}>
          {t("Sélectionnez le type de l'homologation")}
        </span>
      }
      open={openModal !== ""}
      footer={false}
      onCancel={() => setOpenModal("")}
      width={1000}
      centered
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <div
            style={getCardStyle("existante")}
            onClick={() => setSelectedType("existante")}
            onMouseEnter={(e) =>
              (e.currentTarget.style.borderColor = "#214082")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.borderColor =
                selectedType === "existante" ? "#214082" : "#ddd")
            }
          >
            <CheckCircle
              size={32}
              style={{ marginRight: "12px", color: "#214082" }}
            />
            <span>{t("Homologation Existante")}</span>
          </div>

          <div
            style={getCardStyle("nouvelle")}
            onClick={() => setSelectedType("nouvelle")}
            onMouseEnter={(e) =>
              (e.currentTarget.style.borderColor = "#214082")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.borderColor =
                selectedType === "nouvelle" ? "#214082" : "#ddd")
            }
          >
            <PlusCircle
              size={32}
              style={{ marginRight: "12px", color: "#28a745" }}
            />
            <span>{t("Nouvelle Homologation")}</span>
          </div>
        </div>
      </Form>
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <Button
          type="primary"
          disabled={!selectedType}
          style={{
            backgroundColor: "#214082",
            borderColor: "#214082",
            width: "160px",
            height: "45px",
            fontSize: "16px",
            marginRight: "16px",
            color: "white",
          }}
          onClick={() => {
            sessionStorage.removeItem("globalData");
            setGlobalData({});
            form.resetFields();
            navigate("/formations/newHomologation", {
              state: {
                id_formation: data.id,
                epf_data: data.data,
                selectedType: selectedType,
              },
            });
          }}
        >
          {t("Valider")}
        </Button>
        <Button
          onClick={() => setOpenModal("")}
          style={{
            backgroundColor: "#E2E9F7",
            color: "#214082",
            border: "1px solid #9BACCF",
            width: "160px",
            height: "45px",
            fontSize: "16px",
          }}
        >
          {t("Annuler")}
        </Button>
      </div>
    </Modal>
  );
};

export default ModalChooseTypeHomologation;
